module.exports = __webpack_public_path__ + "@/assets/img/kiphu.39f45ef6.png";